export const getTinyMceStyles = () => `
/* TinyMce editor style */

.tox-statusbar__branding {
  display: none;
}
`;
